import { Component, OnInit, Input } from '@angular/core';

import { ComunicadoBase } from '../comunicado-base';
import { ComunicadosService } from '../comunicados.service';
import { Comunicado } from '../../base/vo/comunicado';
@Component({
    selector: 'app-comunicado-simples',
    templateUrl: './comunicado-simples.component.html',
    styleUrls: ['./comunicado-simples.component.css']
})
export class ComunicadoSimplesComponent extends ComunicadoBase implements OnInit {

    constructor(private comunicadosService: ComunicadosService) { 
        super();
    }

    ngOnInit() {
    }

    private getBotao(comunicado: Comunicado): string {
        return comunicado.lido ? '' : 'Marcar como lido';
    }

    private marcarComoLido(comunicado: Comunicado): void {
        this.comunicadosService.marcarLido(comunicado.id)
            .subscribe(
                data => { 
                    comunicado.lido = true;
                    this.getInfoMsg(comunicado);
                    this.getBotao(comunicado);
                },
                err => console.log('Mensagem de erro')
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/comunicados/comunicado-simples/comunicado-simples.component.ts